module.exports = __webpack_public_path__ + "img/r8.dc05a879.jpg";